export default class Parallax {
  constructor() {
    this.windowHeight = window.innerHeight
    this.target = document.querySelectorAll('.parallax-block')
    this.targetData = []
    this.getData()

    this.updateElements()
    this.initEvents()
  }

  /**
   * function initEvents
   * Add event listener
   */
  initEvents() {
    // Disabled because we're using scrollbar
    // window.addEventListener('scroll', evt => this.updateElements(evt))
  }

  /**
   * function updateElements
   * Update translateY value for all targeted element
   * @return void
   */
  updateElements() {
    for (let i = 0; i < this.target.length; i++) {
      if (this.targetData[i].dataDirection == 'down') {
        var offset = this.getTargetPos(this.target[i])*-1
      } else {
        var offset = this.getTargetPos(this.target[i])
      }

      if (this.targetData[i].hadTransform){
        let translateX = this.targetData[i].transform.X
        let translateY = ( parseInt(this.targetData[i].transform.Y) + offset ) * (this.targetData[i].dataSpeed/100)
        
        this.target[i].style.transform = 'translate3d('+ translateX + 'px, ' + translateY + 'px, 0)'

      }else{
        
        this.target[i].style.transform = 'translate3d(0, '+ (offset * (this.targetData[i].dataSpeed/100)) +'px, 0)'
      }
    }
  }

  /**
   * function getData
   * Get the value of data-speed for all target element
   * @return this
   */
  getData() {
    var arr = []

    for (let i = 0; i < this.target.length; i++) {
      var dataSpeed = this.target[i].getAttribute('data-speed') ? this.target[i].getAttribute('data-speed') : 5
      var dataDirection = this.target[i].getAttribute('data-direction') ? this.target[i].getAttribute('data-direction') : 'down'

      var transformMatrix = window.getComputedStyle(this.target[i]).transform

      var hasTransform = transformMatrix != 'none' ? true : false

      var input = {
        dataSpeed: dataSpeed,
        dataDirection: dataDirection,
        hadTransform: hasTransform
      }

      if (hasTransform) {
        const transform = this.transformMatrixToPx(transformMatrix)
        input.transform = transform
      }

      arr.push(input)
    }

    this.targetData = arr
  }

  /**
   * function getTargetPos
   * @param object   Element targeted
   * @return int     Position of the element relatively from the viewport
   */
  getTargetPos(elem) {
    const rect = elem.getBoundingClientRect()
    return rect.top + (rect.height / 2) - (this.windowHeight / 2)
  }

  updateDataElements() {
    this.getData()
    this.updateElements()
  }

  /**
   * function transformMatrixToPx
   * Transform the matrix that we get with elem.getComputedStyle and transform it to px value
   * @param   matrix   string
   * @return   object
   */
  transformMatrixToPx(matrix) {
    var tr = matrix.split('(')[1],
      tr = tr.split(')')[0],
      tr = tr.split(',')

    return {
      X: tr[4],
      Y: tr[5]
    }
  }

  run() {
    this.request = requestAnimationFrame(run);

    this.getData()
    this.updateElements()

    this.run()
  }
}